<template>
  <Base>
    <template v-slot:toolbar>
      <!-- Masque sur mobile : l'en-tete .wm-head le remplace (titre, compteur,
           recherche, action principale). Deux barres l'une sur l'autre. -->
      <div v-if="!isMobile" class="toolbar" id="kt_toolbar">
        <div
          class="container-fluid d-flex flex-stack"
          id="kt_toolbar_container"
        >
          <div class="d-flex align-items-center me-3">
            <slot name="leftToolbar">
              <span class="h-20px border-gray-200 border-start mx-4"></span>
              <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li class="breadcrumb-item text-muted">
                  <router-link
                    :to="{ name: 'dashboard' }"
                    class="text-muted text-hover-primary"
                  >
                    <i class="fad fa-home"></i>
                    {{ trans("Cotations") }}
                  </router-link>
                </li>
              </ul>
            </slot>
          </div>

          <div class="d-flex align-items-center py-1">
            <b-dropdown
              v-if="links.length > 0 && !hasRole('ROLE_MANAGER')"
              id="dropdown-1"
              text="Liens"
              class="m-md-2"
              size="sm"
            >
              <b-dropdown-text
                v-for="(item, index) in links"
                :key="index"
                :to="{ name: 'comparateur-index', params: { link: item.code } }"
              >
                <a
                  :href="item.short"
                  target="_blank"
                  class="dropdown-link d-flex align-items-center justify-content-between px-3 py-2 text-decoration-none"
                  style="transition: background 0.2s"
                >
                  <div class="d-flex align-items-center">
                    <i class="fad fa-file-alt text-primary me-2"></i>
                    <span class="fw-bold">{{ item.survey }}</span>
                  </div>
                </a>
              </b-dropdown-text>
            </b-dropdown>

            <router-link
              target="_blank"
              :to="{ name: 'comparateur-index' }"
              class="btn btn-sm btn-clean btn-dropdown btn-primary"
            >
              <i class="fad fa-file-signature fs-2"></i>
              {{ trans("Effectuer une cotation") }}
            </router-link>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:content>
      <div :class="isMobile ? '' : 'm-5'">
        <!-- Masque sur mobile : l'en-tete .wm-head de CotationSearch porte deja
             l'action principale, ces trois boutons faisaient doublon. -->
        <div v-if="!isMobile" class="btn-group my-5" role="group" aria-label="Basic example">
          <button type="button" class="btn btn-sm btn-icon btn-secondary">
            <i class="fad fa-abacus"></i>
          </button>
          <button type="button" class="btn btn-sm btn-icon btn-secondary">
            <i class="fad fa-th-list"></i>
          </button>
          <button type="button" class="btn btn-sm btn-icon btn-secondary">
            <i class="fad fa-coins"></i>
          </button>
        </div>
        <CotationSearch></CotationSearch>
      </div>
    </template>
  </Base>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Base from "@/layouts/Base.vue";
import MobileAware from "@/mixins/MobileAware";
import Survey from "@/entity/Survey";
import Branch from "@/entity/Branch";
import BranchCategory from "@/entity/BranchCategory";
import { api } from "@/services/Api";
import SavedResponseGroup from "@/views/Income/Comparator/SavedResponseGroup.vue";
import InputNumber from "@/components/InputNumber.vue";
import ResponseGroup from "@/entity/ResponseGroup";
import Popup from "@/entity/Popup";
import VueMultiselect from "vue-multiselect/src/Multiselect.vue";
import CONSTANTS from "@/Utils/constant";
import CotationSearch from "@/views/Income/CotationSearch.vue";
import Loading from "@/components/Loading.vue";
import PartnerLink from "../../entity/PartnerLink";

@Component({
  // `mixins` en OPTION : `extends mixins(...)` fait perdre le typage de Vue.
  mixins: [MobileAware],
  components: {
    Loading,
    CotationSearch,
    VueMultiselect,
    InputNumber,
    SavedResponseGroup,
    Base,
  },
})
export default class CotationList extends Vue {
  // Fourni par le mixin MobileAware (declaration de type seulement).
  isMobile!: boolean;

  [x: string]: any;

  categories: BranchCategory[] = [];
  currentCategory: any = null;

  isLoading = false;

  mounted() {
    this.load();
    this.searchLinkPartner();
  }

  async load() {
    this.isLoading = true;
    this.$store.commit("loading");
    this.categories = await this.$store.getters.branchCategories();
    if (this.currentCategory === null && this.categories.length > 0) {
      this.currentCategory = this.categories[0].uuid;
    }
    this.$store.commit("stopLoading");
    this.isLoading = false;
  }

  ç;

  links: PartnerLink[] = [];
  async searchLinkPartner() {
    const res = await api.get(api.core, "partner/get/custom/links");

    if (res && res.data && res.data.links) {
      this.links = res.data.links;
    }
  }

  copyToClipboard(text: string) {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(text);
      // @ts-ignore
      if (this.$bvToast) {
        // @ts-ignore
        this.$bvToast.toast("Lien copié !", {
          variant: "success",
          autoHideDelay: 1500,
        });
      } else {
        alert("Lien copié !");
      }
    }
  }
}
</script>
<style scoped>
.branch-button {
  position: relative;
}

.branch-button:hover:before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  opacity: 0.1;
  background: var(--bg-hover);
}

.branch-button:hover * {
  color: var(--bg-hover) !important;
}
</style>

<style>
.dropdown-menu {
  padding: 0 !important;
}

.dropdown-link:hover {
  background: #f4f6fa;
  text-decoration: none;
}
</style>
